module.exports = __webpack_public_path__ + "img/bg-huge.0d5bee2d.svg";